const DEV_BUCKET = 'https://storage.googleapis.com/test-webfiles'
const REAL_BUCKET = 'https://storage.googleapis.com/my-project-o2o.appspot.com'
const BUCKET_URL = process.env.VUE_APP_BUCKET_URL || REAL_BUCKET

export const resolveImage = (imagePathOrData, bucketUrl = BUCKET_URL) => {
  if (typeof imagePathOrData != 'string') {
    return imagePathOrData
  }
  if (!imagePathOrData || /^(?:https?:|data:|blob:|\/\/)/i.test(imagePathOrData)) {
    return imagePathOrData
  }
  return bucketUrl.replace(/\/$/, '') + '/' + imagePathOrData.replace(/^\//, '')
}

// 개발 버킷에서 읽을 수 없는 업로드 이미지만 동일 경로의 운영 이미지를 시도한다.
export const imageFallbackSources = (src, bucketUrl = BUCKET_URL, environment = process.env.VUE_APP_DEPLOYMENT_ENV) => {
  const primary = resolveImage(src, bucketUrl)
  if (!primary) return []
  return environment === 'development' &&
    bucketUrl.replace(/\/$/, '') === DEV_BUCKET &&
    primary.startsWith(DEV_BUCKET + '/upload/')
    ? [primary, REAL_BUCKET + primary.slice(DEV_BUCKET.length)]
    : [primary]
}
